var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-router-container",attrs:{"id":"app-layout-admin"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }